/**
 * Route serving the `.ics` file for the Apple option.
 *
 * Lives in its own constants module rather than beside the URL builder because the SSR server
 * registers this path (`server/middleware/calendarIcs.ts`) and logs against it
 * (`server/middleware/morganFormatter.ts`). Importing it from a component's utils would put a
 * UI module on the server's import graph, where a future React or DOM dependency added to that
 * file would follow it in.
 */
export const CALENDAR_ICS_PATH = '/api/calendar/ics';
